import { useEffect, useState } from "react";

export const SideRail = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const pct = total > 0 ? (h.scrollTop / total) * 100 : 0;
      setProgress(pct);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="side-rail"
      aria-hidden="true"
      className="hidden lg:flex fixed right-6 top-1/2 -translate-y-1/2 z-30 flex-col items-center gap-3 pointer-events-none"
    >
      <div className="text-[10px] uppercase tracking-[0.3em] text-white/30 rotate-90 origin-center mb-6">
        Scroll
      </div>
      <div className="relative w-[2px] h-48 bg-white/10 rounded-full overflow-hidden">
        <div
          className="absolute left-0 top-0 w-full rounded-full transition-[height] duration-150"
          style={{
            height: `${progress}%`,
            background: "linear-gradient(180deg, #16D1C8, #FF2D7A)",
          }}
        />
      </div>
      <div className="text-[10px] mt-4 font-mono tabular-nums text-white/40">{Math.round(progress)}%</div>
    </div>
  );
};
